import React from "react"
import { columnsFor } from "./Grid"

const ROWS = 6

const GridSkeleton = ({ days }) => {
  const mode = days > 7 ? "month" : "week"
  return (
    <div className="bg-white border border-slate-200 rounded-xl overflow-hidden" aria-busy="true">
      <div className="grid" style={{ gridTemplateColumns: columnsFor(days, mode) }}>
        <div className="h-[58px] border-b border-r border-slate-200 px-3 flex items-center">
          <span className="hb-shimmer h-[10px] w-[90px] rounded" />
        </div>
        {Array.from({ length: days }).map((_, index) => (
          <div key={index} className="h-[58px] border-b border-slate-200 flex flex-col items-center justify-center gap-1.5">
            <span className="hb-shimmer h-[8px] w-[24px] rounded" />
            <span className="hb-shimmer h-[18px] w-[18px] rounded-full" />
          </div>
        ))}
        <div className="h-[58px] border-b border-l border-slate-200" />

        {Array.from({ length: ROWS }).map((_, row) => (
          <React.Fragment key={row}>
            <div className="flex items-center gap-2.5 px-3 py-2 border-b border-r border-slate-100">
              <span className="hb-shimmer w-[30px] h-[30px] rounded-full" />
              <span className="flex flex-col gap-1.5">
                <span className="hb-shimmer h-[9px] w-[110px] rounded" />
                <span className="hb-shimmer h-[7px] w-[70px] rounded" />
              </span>
            </div>
            {Array.from({ length: days }).map((_, index) => (
              <div key={index} className="p-[3px] border-b border-slate-100">
                <div className="hb-shimmer rounded-md" style={{ height: mode === "month" ? 50 : 64, opacity: 0.55 + ((row + index) % 3) * 0.15 }} />
              </div>
            ))}
            <div className="border-b border-l border-slate-100 flex items-center justify-end px-3">
              <span className="hb-shimmer h-[10px] w-[40px] rounded" />
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export default GridSkeleton
